import { Navigate, Outlet } from 'react-router-dom';

import { getAccessToken } from '@/api/token';
import { PRIVATE_ROUTES } from '@/router/constant/routes';

export function PublicRoute() {
    const token = getAccessToken();

    if (token) {
        return <Navigate to={PRIVATE_ROUTES.HOME} replace />;
    }

    return <Outlet />;
}
